import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@/app/environments/environment';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';

@Component({
  selector: 'app-attachment-list',
  standalone: true,
  imports: [CommonModule, MatListModule],
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss'],
})
export class AttachmentListComponent implements OnInit {
  @Input() attachments: any[] = []; // Array of attachments

  @Input() config: {
    fileNameKey?: string;
    filePathKey?: string;
    filter_key?: string;
    filter_value?: string;
  } = {};

  private apiUrl = environment.apiUrl + '/organizations/projects/documents'; // Laravel API URL

  constructor(private http: HttpClient,
    private getFileIconService: GetFileIconUtilityService
  ) {}

  ngOnInit(): void {
    // Ensure config has defaults if missing
    this.config = {
      fileNameKey: this.config?.fileNameKey ?? 'title',
      filePathKey: this.config?.filePathKey ?? 'file_path',
      filter_key: this.config?.filter_key,
      filter_value: this.config?.filter_value,
    };
  }
  getFileIcon(file: { file: File; preview: string; id?: number; name?: string }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  // Getter to filter attachments dynamically
  get filteredAttachments(): any[] {
    if (this.config.filter_key && this.config.filter_value) {
      return this.attachments.filter(
        (item) => item[this.config.filter_key!] === this.config.filter_value
      );
    }
    return this.attachments;
  }

  downloadFile(documentId: string, fileName: string) {
    const token = localStorage.getItem('authToken'); // Retrieve JWT token
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    this.http
      .get(`${this.apiUrl}/${documentId}`, { headers, responseType: 'blob' })
      .subscribe(
        (file) => {
          const blob = new Blob([file]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName; // Use the provided file name
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        (error) => {
          console.error('Error downloading file:', error);
        }
      );
  }
}
